import load from './modules/load-assets';
import lazy from './modules/lazy-image-load';
import easyReveal from './modules/easyReveal';
import carousel from './modules/carousel';
import stream from './modules/stream';

const theme = document.body.getAttribute('data-theme');
const v = document.body.getAttribute('data-version');

console.log( v, theme );

easyReveal.init();
//initialize lazy load of images
lazy.init('[data-src]');
//background videos
stream.init( '[data-background-video]' );
//load google fonts
load.asset('https://fonts.googleapis.com/css2?family=Poppins:wght@400;800&display=swap', 'link', ()=>{
     document.body.classList.add('font-b');
}, true);

const carousels = document.querySelectorAll( '[data-carousel]' );
if( carousels.length > 0 ) {
    if( !window.splide ) {
        load.dependencies([
            { src : `${theme}/assets/css/splide-core.min.css`, type : 'link' },
            { src : `${theme}/assets/css/splide.min.css`, type : 'link' },
            { src : `${theme}/assets/js/vendor/splide.min.js`, type : 'script' },
        ], ()=> {
            window.splide = true;
            carousel( carousels );
        })
    } else {
        carousel( carousels );
    }
}

const drawers = document.querySelectorAll('[data-component-accordion]');
if( drawers.length > 0 ) {
     drawers.forEach( drawer => {
          drawer.addEventListener( 'click', ()=>{
            drawer.classList.toggle('active');
            const container = drawer.nextElementSibling;
            const height = container.clientHeight;
            const scroll = container.scrollHeight;
            console.log( container, height, scroll );
            height < scroll ? container.style.maxHeight = `${scroll}px` : container.style.maxHeight = 0;
          }, {passive:true} );
     } )
}